import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { palette } from 'theme';

import Typography from '@material-ui/core/Typography';

const TOCList = styled.ul`
  column-gap: 0;
  margin: 0;
  padding: 0;
  list-style-type: none;
  @media (min-width: 600px) {
    column-count: 2;
  }
`;

const TOCListItem = styled.li`
  break-inside: avoid-column;
  padding: 5px;
`;

const TOCNumber = styled(Typography)`
  font-size: 1em;
`;

const TOCLink = styled(Link)`
  display: block;
  padding: 10px;
  text-decoration: none;
  border-radius: 3px;

  &:hover {
    background-color: ${palette.grey[50]};
  }
`;

class TOC extends React.PureComponent {
  render() {
    const { chapters } = this.props;

    return (
      <TOCList>
        {chapters.map((chapter, idx) => (
          <TOCListItem key={idx}>
            <TOCLink to={chapter.url}>
              <div>
                <TOCNumber variant="overline" component="span">
                  Chapter {String(idx + 1).padStart(2, 0)}
                </TOCNumber>
                <Typography variant="subtitle2" component="div">
                  {chapter.title}
                </Typography>
              </div>
            </TOCLink>
          </TOCListItem>
        ))}
      </TOCList>
    );
  }
}

TOC.propTypes = {
  chapters: PropTypes.array.isRequired
};

export default TOC;
